export default __webpack_public_path__ + "static/tech-sheet-desktop-0b435214d67edeb5721ceaaee290d82d.png";